export const RESET_COMPANIES = "RESET_COMPANIES";
export const RESET_COMPANY = "RESET_COMPANY";
export const RESET_ERROR = "RESET_ERROR";

export const GET_COMPANIES = "GET_COMPANIES";
export const SET_COMPANIES = "SET_COMPANIES";

export const API_ERROR = "COMPANIES_API_ERROR";

export const GET_COMPANY = "GET_COMPANY";
export const SET_COMPANY = "SET_COMPANY";

export const EDIT_COMPANY = "EDIT_COMPANY";
export const EDIT_COMPANY_SUCCESS = "EDIT_COMPANY_SUCCESS";

export const CREATE_COMPANY = "CREATE_COMPANY";
export const CREATE_COMPANY_SUCCESS = "CREATE_COMPANY_SUCCESS";

export const ACTIVATE_COMPANY = "ACTIVATE_COMPANY";
export const ACTIVATE_COMPANY_SUCCESS = "ACTIVATE_COMPANY_SUCCESS";

export const CLEAN_QUEUE = "CLEAN_QUEUE";
export const CLEAN_QUEUE_SUCCESS = "CLEAN_QUEUE_SUCCESS";
export const RESET_SUCCESS = "RESET_SUCCESS";
